import { createSelector } from 'reselect';

const selectReconciliationRequests = (state: any) => state.reconciliationRequests;


export const selectReconciliationRequestCurrentItem = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.current);

export const selectReconciliationRequestsListItems = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.list);

export const selectReconciliationRequestItemById = (itemId: any) =>
    createSelector(selectReconciliationRequestsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectReconciliationRequestQueryItems = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.query);

export const selectReconciliationRequestCreatedItem = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.create);

export const selectReconciliationRequestUpdatedItem = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.update);

export const selectReconciliationRequestReadItem = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.read);

export const selectReconciliationRequestDeletedItem = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.delete);

export const selectReconciliationRequestSearchedItems = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.search);

export const selectReconciliationRequestItemsCount = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.count);

export const selectReconciliationRequestItemsFilter = createSelector([selectReconciliationRequests], (reconciliationRequests) => reconciliationRequests.filter);